import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PawnDataService {
   http_url = environment.apiSite + environment.apiService;  
   public usuario : any;
   public listaFacturas: any;

  constructor(public http: HttpClient, private config: ConfigService) {
  
  }

  /* recibo un query y lo ejecuta en el server */

  execQuery(tipo, qry){
    let datos = { operacion: tipo, sql: qry };
    return this.http.post(this.http_url + "execsql", JSON.stringify(datos));
  }


  loginUser(mail){
    let datos = { email: mail };
    console.log(datos);
    return this.http.post(this.http_url + "getuser", JSON.stringify(datos));
  }

  facturas(documento){
    let datos = { cedula: documento };
    return this.http.post(this.http_url + "facturas", JSON.stringify(datos));
  }

  detalles(id){
    let datos = { id: id };
    return this.http.post(this.http_url + "factura_detalle", JSON.stringify(datos));
  }


  getInfoEmpresa(){

    let datos = { nombre:'Marcial Caballero',email:'marcial.cab@gmail.com'};
     return this.http.post(this.http_url + "infoempresa", JSON.stringify(datos));
  }

}

